module.exports = __webpack_public_path__ + "static/media/me-2.b80888da.svg";